import {
    createReducer,
    createActionResources,
    createActionCRUDResources
  } from "redux-waiters";
  import { RESET_REDUCER } from "../constants";
  
  export const searchWelcomeVideoAction = createActionResources("videos-welcome/search");
  export const pinVideoAction = createActionResources("videos-welcome/set-pin");
  export const welcomeVideoAction = createActionCRUDResources("videos-welcome");
  export const enableAction = createActionResources("videos-welcome/enable");
  export const disableAction = createActionResources("videos-welcome/disable");
  export const resyncAction = createActionResources("videos-welcome/resync");
  
  const initialState = {
    fetching: false,
    list: [],
    total: 0,
    totalPages: 0,
    pageNumber: 1,
    user: {},
    error: {},
  };
  
  export default createReducer(
    {
      [welcomeVideoAction.fetch.start]: state => {
        return { ...state, fetching: true };
      },
      [welcomeVideoAction.fetch.success]: (state, action) => {
        return {
          ...state,
          list: action.data?.content,
          pageNumber: action.data?.pageNumber + 1,
          total: action.data?.total,
          totalPages: Math.ceil(action.data?.total / action.data?.pageSize),
          fetching: false,
        };
      },
      [welcomeVideoAction.fetch.error]: state => {
        return { ...state, fetching: false };
      },
  
      [RESET_REDUCER]: () => initialState,
    },
    initialState
  );
  